import { deleteConfirmationAlert,timePickerMask } from "./common";

window.addEventListener('DOMContentLoaded', (event) => {
    timePickerMask();
    let rt = window.$;
    // FOR ALL DAY CHECKBOX
    rt("#allday").on('click', function(e) {
        if (rt(this).is(':checked')) {
            rt(this).prop('checked', true);
            rt("input.daysname[type=checkbox]").each(function() {
                rt(this).prop('checked', true);
            });
        } else if (!rt(this).is(':checked')) {
            rt("input.daysname[type=checkbox]").each(function() {
                rt(this).prop('checked', false);
            });
        }
    });
    // FOR INDIDUVAL DAYS CHECKBOX
    rt(".daysname").on('click', function(e) {
        if (rt(this).is(':checked')) {
            let checkedboxLength = rt(".daysname:checked").length;
            if (checkedboxLength == 7) {
                rt("#allday").prop('checked', true)
            } else {
                rt("#allday").prop('checked', false)
            }
        } else if (!rt(this).is(':checked')) {
            if (rt("#allday").is(':checked')) {
                rt("#allday").prop('checked', false)
            }
        }
    });
    //MIN HOUR AND MAX HOUR VALIDAITON
    let min_hours_ele = rt("#retentionTimes_min");
    let max_hours_ele = rt("#retentionTimes_max");

    min_hours_ele.on('change', function() {
        if (rt(this).val() > max_hours_ele.val()) {

        }
    });

    max_hours_ele.on('change', function(e) {
        if (rt(this).val() < min_hours_ele.val()) {

        }
    });

    // SAVE RETENTION TIME
    rt("#saveRetentionTime").on('click', function() {
        let formdata = rt("#retentionTimes_form").serialize();
        let URL = rt("#retentionTimes_form").attr('action');
        let redirectto = rt("#retentionTimes_form").attr('redirectto');
        window.axios({
                method: "post",
                url: URL,
                data: formdata,
            })
            .then(function(response) {
                window.location = redirectto;
            })
            .catch(function(error) {
                if (error.response) {
                    if (error.response.data.message) {
                        window.toastr.error(error.response.data.message, error.response.statusText);
                    } else {
                        for (const errordata in error.response.data) {
                            if (error.response.data[errordata] !== undefined) {
                                setTimeout(function() {
                                    window.$("#" + errordata).css('border:1px solid red;');
                                }, 250)
                                window.toastr.error(error.response.data[errordata][0]);
                            }
                        }
                    }

                }
            });
    });

    // data table for retentiontime listing
    var table = window.$('.retentionTable').DataTable({
        "ordering": false,
        "searching": false,
        "info": false,
        processing: true,
        serverSide: true,
        "ajax": {
            "url": window.$(".retentionTable").attr('link'),
            "type": "GET"
        },
        columns: [
            { data: 'guestCount', name: 'Guest Count' },
            { data: 'retentionTime', name: 'Retention time (min - max)' },
            { data: 'startandendtime', name: 'Start - end time' },
            { data: 'monday', name: 'Monday' },
            { data: 'tuesday', name: 'Tuesday' },
            { data: 'wednesday', name: 'Wednesday' },
            { data: 'thursday', name: 'Thursday' },
            { data: 'friday', name: 'Friday' },
            { data: 'saturday', name: 'Saturday' },
            { data: 'sunday', name: 'Sunday' },
            { data: 'action', name: 'Action', orderable: false, searchable: false }
        ]
    });

    /**
     * Delete Retention
     */
    window.$(document).on('click', '.deleteRetention', function(e) {
        var currentObj = window.$(this);
        // Call method for delete confirmation
        var promise = deleteConfirmationAlert();
        promise.then(function(result) {
            // If confirmation true, do action for delete
            var myTable = $(".retentionTable").DataTable({
                bRetrieve: true,
                ajax: window.$(".retentionTable").attr('link')
            });
            e.preventDefault();
            window.axios({
                    method: "DELETE",
                    url: currentObj.attr('link')
                })
                .then(function(response) {
                    myTable.ajax.reload();
                    window.toastr.success(response.data.message, response.statusText);
                })
                .catch(function(error) {
                    window.toastr.error(error.response.data.message, error.response.data.statusText);

                });
            return false;

        }).catch(function(err) {
            console.log(err);
            return false;
        });

    });

});